export enum TERMINALS_LINKS_KEYS {
  ALL = 'all-terminals-links',
  TERMINAL_LINK = 'terminal-link',
  TERMINAL_LINK_ACTION = 'terminal-link-action',
  TERMINAL_LINK_GROUP_TL_LIST = 'terminal-link-group-tl-list',
  TERMINAL_LINK_HEALTH = 'terminal-link-health',
  TERMINAL_LINK_LIMITS = 'terminal-link-limits',
  TERMINAL_LINK_LIST = 'terminal-link-list',
  TERMINAL_LINK_PARAMETER_LOWER_LEVEL_VALUES = 'terminal-link-parameter-lower-level-values',
  TERMINAL_LINK_REQUIRED_PARAMETERS = 'terminal-link-required-parameters',
  TERMINAL_LINK_SETTLEMENT_CONFIGS = 'terminal-link-settlement-configs',
  TERMINAL_LINKS_ACTIONS = 'terminal-links-actions',
  TERMINAL_LINKS_GROUP = 'terminal-links-group',
  TERMINAL_LINKS_GROUP_LIMITS = 'terminal-links-group-limits',
  TERMINAL_LINKS_GROUP_TL = 'terminal-links-group-tl',
  TERMINAL_LINKS_GROUP_UNIQUE_CUSTOMER_ID_COUNTS = 'terminal-links-group-unique-customer-id-counts',
  TERMINAL_LINKS_GROUPS_LIST = 'terminal-links-groups-list',
  TERMINAL_LINKS_LIMITS = 'terminals-links-limits',
  TERMINAL_LINKS_PARAMETERS = 'terminal-links-parameters',
  TERMINAL_LINKS_PARAMETERS_NAMES = 'terminal-links-parameters-names',
}

export const INITIAL_OFF_COLUMNS_TERMINAL_LINKS = [
  'threeDSEnabled',
  'webhooksEnabled',
  'motoEnabled',
  'exitIFrame',
  'recurringEnabled',
  'trusted',
  'limitsEnabled',
  'merchantTerminal.merchant.name',
  'useCustomActions',
  'bankTerminal.bank.adapterCode',
  'pspSendPaymentTimeoutSeconds',
  'checkStatusOnEarlyWebhook',
  'checkStatusOnEarlyWebhookDelaySeconds',
];

export const MAIN_COLUMNS = ['description'];

export const DEFAULT_LIKES_FIELDS = ['description'];

export enum ISSUING_ORG_OPERATION {
  IN = 'in',
  NOT_IN = 'ni',
}

export const ISSUING_ORG_OPERATIONS = Object.values(ISSUING_ORG_OPERATION);

export const INITIAL_OFF_COLUMNS_TERMINAL_LINKS_LIMITS = [
  'lastUpdated',
  'merchant',
  'merchantId',
  'merchantTerminalName',
  'merchantTerminalId',
  'bankName',
  'bankId',
  'paymentMethod',
];

export const INITIAL_OFF_COLUMNS_TERMINAL_LINKS_PARAMETERS = [
  'paramId',
  'paymentMethod',
  'terminalLinkId',
  'merchantTerminalName',
  'merchantName',
];

export const DEFAULT_LIKES_TL_PARAMETERS_FIELDS = ['terminalLinkDescription', 'bankName'];

export enum CARDHOLDER_OVERRIDE_TYPES {
  CUSTOM_OVERRIDE = 'CUSTOM_OVERRIDE',
  DEFAULT = 'DEFAULT',
  FORCED_OVERRIDE = 'FORCED_OVERRIDE',
}

export enum COUNT_OF {
  TRANSACTIONS = 'TRANSACTIONS',
  UNIQUE_CUSTOMERS = 'UNIQUE_CUSTOMERS',
  UNIQUE_INSTRUMENTS = 'UNIQUE_INSTRUMENTS',
}

export enum UNIQUE_CUSTOMER_ID_TYPES {
  ACCOUNT_ID = 'ACCOUNT_ID',
  CUSTOMER_ID = 'CUSTOMER_ID',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export const INITIAL_OFF_COLUMNS_TERMINAL_LINKS_GROUPS = ['merchant.name'];

export const MAIN_COLUMNS_TERMINAL_LINKS_GROUPS = ['name'];

export const WEEKS_LIST_TERMINAL_LINKS_LIMITS = new Set(['customPeriod']);

export const DAYS_LIST_TERMINAL_LINKS = new Set([
  'payoutTimeout',
  'purchaseTimeout',
  'refundTimeout',
]);

export enum INTEGRATION_REQUIRED_PARAMETER_TYPE {
  INPUT = 'INPUT',
  SELECT = 'SELECT',
}

export const INTEGRATION_REQUIRED_PARAMETER_TYPE_MAP = {
  [INTEGRATION_REQUIRED_PARAMETER_TYPE.INPUT]: 'INPUT_FIELD',
  [INTEGRATION_REQUIRED_PARAMETER_TYPE.SELECT]: 'DROPDOWN_FIELD',
};

export enum INTEGRATION_REQUIRED_INPUT_TYPE {
  EMAIL = 'email',
  FILE = 'file',
  TELEPHONE = 'tel',
  TEXT = 'text',
}

export const INTEGRATION_REQUIRED_INPUT_TYPE_MAP = {
  [INTEGRATION_REQUIRED_INPUT_TYPE.EMAIL]: 'EMAIL',
  [INTEGRATION_REQUIRED_INPUT_TYPE.FILE]: 'FILE',
  [INTEGRATION_REQUIRED_INPUT_TYPE.TELEPHONE]: 'TELEPHONE',
  [INTEGRATION_REQUIRED_INPUT_TYPE.TEXT]: 'TEXT',
};

export enum INTEGRATION_REQUIRED_CLASS_TYPE {
  DATE_PATTERN = 'date-pattern',
  NUMERIC = 'NUMERIC',
}

export const INTEGRATION_REQUIRED_INPUT_CLASS_MAP = {
  [INTEGRATION_REQUIRED_CLASS_TYPE.DATE_PATTERN]: 'DATE_PATTERN',
  [INTEGRATION_REQUIRED_CLASS_TYPE.NUMERIC]: 'NUMERIC',
};

export enum COPIED_LIMIT_STATUS {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  SAME_AS_SOURCE = 'SAME_AS_SOURCE',
}

export enum COPY_LIMITS_SOURCE_TYPE {
  TERMINAL_LINK = 'TERMINAL_LINK',
  TERMINAL_LINK_GROUP = 'TERMINAL_LINK_GROUP',
}

export enum COPY_LIMITS_TARGET_STATUS {
  FAILED = 'FAILED',
  NO_ACCESS = 'NO_ACCESS',
  NOT_FOUND = 'NOT_FOUND',
  OK = 'OK',
}

export enum COPY_LIMITS_TARGET_TYPE {
  TERMINAL_LINK_GROUPS = 'TERMINAL_LINK_GROUPS',
  TERMINAL_LINKS = 'TERMINAL_LINKS',
}

export enum COPY_LIMITS_WARNING_CODE {
  PAYMENT_METHOD_NOT_CARD = 'PAYMENT_METHOD_NOT_CARD',
  UNIQUE_CUSTOMER_ID_MISMATCH = 'UNIQUE_CUSTOMER_ID_MISMATCH',
}

export enum EXISTING_LIMITS_MODE {
  SKIP_IDENTICAL = 'SKIP_IDENTICAL',
  SKIP_SAME_KIND = 'SKIP_SAME_KIND',
}
